import { Injectable } from '@angular/core';
import {
  AssetListSortType,
  AssetListSortTypes,
  AssetListViewType,
  AssetListViewTypes,
  ExportOrientationType,
  ExportOrientationTypes,
} from '../../../shared/models';
import {
  AssetListViewAction,
  AssetListSortAction,
  AssetListExportOrientationAction,
} from '../interfaces/asset-list-actions.interfaces';
import { ColumnViewIconComponent } from '../../svg/column-view-icon/column-view-icon.component';
import { ListViewIconComponent } from '../../svg/list-view-icon/list-view-icon.component';

@Injectable({
  providedIn: 'root',
})
export class AssetListActionConfigService {
  public createViewActions(onViewModeChange: (mode: AssetListViewTypes) => void): AssetListViewAction[] {
    return [
      {
        icon: ColumnViewIconComponent,
        name: AssetListViewType.column,
        action: () => onViewModeChange(AssetListViewType.column),
      },
      {
        icon: ListViewIconComponent,
        name: AssetListViewType.list,
        action: () => onViewModeChange(AssetListViewType.list),
      },
    ];
  }

  public createExportOrientationActions(
    onOrientationChange: (orientation: ExportOrientationTypes) => void
  ): AssetListExportOrientationAction[] {
    return [
      {
        name: ExportOrientationType.landscape,
        action: () => onOrientationChange(ExportOrientationType.landscape),
      },
      {
        name: ExportOrientationType.portrait,
        action: () => onOrientationChange(ExportOrientationType.portrait),
      },
    ];
  }

  public createSortActions(onSortChange: (sort: AssetListSortTypes) => void): AssetListSortAction[] {
    return [
      {
        name: AssetListSortType.releaseDate,
        action: () => onSortChange(AssetListSortType.releaseDate),
      },
      {
        name: AssetListSortType.status,
        action: () => onSortChange(AssetListSortType.status),
      },
      {
        name: AssetListSortType.lastUpdated,
        action: () => onSortChange(AssetListSortType.lastUpdated),
      },
      {
        name: AssetListSortType.alphabetical,
        action: () => onSortChange(AssetListSortType.alphabetical),
      },
    ];
  }
}
